import React from 'react';

const Scheduler = () => <div><h2>Slot Scheduler</h2><p>Feature coming soon.</p></div>;

export default Scheduler; 